import React from "react";

const Dashboard = () => {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>Content of the dashboard page...</p>
    </div>
  );
};

export default Dashboard;
